import React, { Component } from 'react'

import { detectAndShowErrors, filterObject, normaliseMap } from './utils'

import Header from './header'
import Progress from '../containers/progress'

import { formHandler, Button } from './ui'

import {
    AdditionalCities,
    EmergencyForm,
    InsuranceForm,
    InternetConnectionForm,
    PersonalForm,
    PhotoForm,
    SmartphoneForm,
    TransportationForm,
} from './personal/index'

/* eslint-disable react/prop-types */

export default class Personal extends Component {
    constructor(props) {
        super(props)

        this.state = {
            data: this.props.personal.data,
        }

        this.updateValue = formHandler.updateValue.bind(this)
        this.countryDialCodeOptions = this.countryDialCodeOptions.bind(this)
        this.loadRegions = this.loadRegions.bind(this)
        this.cityOptions = this.cityOptions.bind(this)
        this.loadCities = this.loadCities.bind(this)
        this.getCountryCode = this.getCountryCode.bind(this)
    }

    componentWillMount() {
        this.props.actions.loadPersonal(this.props.account.user.crew.uuid)

        if (! this.props.location.countries) {
            this.props.location_actions.loadCountries()
        }
        if (this.props.personal.data && this.props.personal.data.country && ! this.props.location.regions) {
            this.loadRegions(this.props.personal.data.country)
        }
        if (! this.props.crew.insurance_type) {
            this.props.crew_actions.loadInsuranceTypes()
        }
        if (! this.props.crew.vehicle_types) {
            this.props.crew_actions.loadVehicleTypes()
        }
        if (! this.props.crew.vehicle_makes) {
            this.props.crew_actions.loadVehicleMakes()
        }
    }

    componentWillReceiveProps(nextProps) {
        // Update the state data when we receive new personal data props
        if (nextProps.personal && ! (
            this.props.personal &&
            nextProps.personal.data === this.props.personal.data
        )) {
            this.setState({
                data: nextProps.personal.data,
            })

            if (nextProps.personal.data.country && ! this.props.location.regions) {
                this.loadRegions(nextProps.personal.data.country)
            }
        }

        detectAndShowErrors(this.props, nextProps, 'personal.errors')
    }

    submitPersonal = () => {
        this.props.actions.submitPersonal(this.state.data, this.props.account.user.crew.uuid)
    }

    updateValueAndSendPatchRequest = (data) => {
        this.updateValue(data)
        this.sendPatchRequest(data)
    }

    sendPatchRequest = (data) => {
        // if an array of fields was passed in, use that to just get data from the state
        if (Array.isArray(data)) {
            data = filterObject(this.state.data, data)
        }

        this.props.actions.patchPersonal(data, this.props.account.user.crew.uuid)
    }

    getCountryCode(country_uuid) {
        if (! this.props.location.countries) {
            return null
        }

        for (const country of this.props.location.countries) {
            if (country.value === country_uuid) {
                return country.code
            }
        }

        return null
    }

    cityOptions() {
        if (! this.props.location.cities) {
            return []
        }

        return this.props.location.cities
    }

    countryDialCodeOptions() {
        if (! this.props.location.countries) {
            return []
        }

        return this.props.location.countries.map((item) => {
            let label = item.label

            if (item.dial_code) {
                label += ` (${ item.dial_code })`
            }

            return {
                value: item.value,
                label,
            }
        })
    }

    loadRegions(country) {
        this.props.location_actions.loadRegions(country)
    }

    loadCities(country, region, query) {
        this.props.location_actions.loadCities(country, region, query)
    }

    render() {
        if (! (this.props.personal && this.props.personal.data)) {
            return null
        }

        const options = {
            countryOptions: this.props.location.countries,
            countryDialCodeOptions: this.countryDialCodeOptions,
            regions: this.props.location.regions,
            cities: this.cityOptions(),
            loadRegions: this.loadRegions,
            loadCities: this.loadCities,
            getCountryCode: this.getCountryCode,
            insuranceTypeOptions: normaliseMap(this.props.crew.insurance_type),
            vehicleTypeOptions: normaliseMap(this.props.crew.vehicle_types),
            vehicleMakeOptions: normaliseMap(this.props.crew.vehicle_makes),
        }

        return (
            <div>
                <Header title="Personal" />

                <div className="content">
                    <Progress stage="personal" />

                    <div className="content__inner">
                        <div className="box">
                            <div className="box__header">
                                <div className="box__title">
                                    Profile Photo
                                </div>
                            </div>
                            <div className="box__content box__content--padded">
                                <PhotoForm
                                    actions={ this.props.actions }
                                    data={ this.state.data }
                                    errors={ this.props.personal.errors }
                                    options={ options }
                                    photo={ this.props.personal.photo }
                                    progress={ this.props.personal.photo_upload_progress }
                                />
                            </div>
                        </div>
                    </div>
                    <div className="content__inner">
                        <div className="box">
                            <div className="box__header">
                                <div className="box__title">
                                    Bio & Personal Details
                                </div>
                            </div>
                            <div className="box__content box__content--padded">
                                <PersonalForm
                                    data={ this.state.data }
                                    errors={ this.props.personal.errors }
                                    options={ options }
                                    updateValue={ this.updateValue }
                                    updateValueAndSendPatchRequest={ this.updateValueAndSendPatchRequest }
                                />
                            </div>
                        </div>
                    </div>
                    <div className="content__inner">
                        <div className="box">
                            <div className="box__header">
                                <div className="box__title">
                                    Emergency Contact
                                </div>
                            </div>
                            <div className="box__content box__content--padded">
                                <EmergencyForm
                                    data={ this.state.data }
                                    errors={ this.props.personal.errors }
                                    options={ options }
                                    updateValue={ this.updateValue }
                                    updateValueAndSendPatchRequest={ this.updateValueAndSendPatchRequest }
                                />
                            </div>
                        </div>
                    </div>
                    <div className="content__inner">
                        <div className="box">
                            <div className="box__header">
                                <div className="box__title">
                                    Transportation
                                </div>
                            </div>
                            <div className="box__content box__content--padded">
                                <TransportationForm
                                    data={ this.state.data }
                                    errors={ this.props.personal.errors }
                                    options={ options }
                                    updateValue={ this.updateValue }
                                    updateValueAndSendPatchRequest={ this.updateValueAndSendPatchRequest }
                                />
                            </div>
                        </div>
                    </div>
                    <div className="content__inner">
                        <div className="box">
                            <div className="box__header">
                                <div className="box__title">
                                    Working In Other Local Cities
                                </div>
                            </div>
                            <div className="box__content box__content--padded">
                                <AdditionalCities
                                    country={ this.state.data ? this.state.data.country : null }
                                    countryCode={ this.state.data ? this.state.data.country_code : null }
                                    crewUUID={ this.props.account.user.crew.uuid }
                                    data={ this.state.data }
                                    errors={ this.props.personal.errors }
                                    modalActions={ this.props.modalActions }
                                    personalActions={ this.props.actions }
                                />
                            </div>
                        </div>
                    </div>
                    <div className="content__inner">
                        <div className="box">
                            <div className="box__header">
                                <div className="box__title">
                                    Smart Phone
                                </div>
                            </div>
                            <div className="box__content box__content--padded">
                                <SmartphoneForm
                                    data={ this.state.data }
                                    errors={ this.props.personal.errors }
                                    updateValue={ this.updateValue }
                                    updateValueAndSendPatchRequest={ this.updateValueAndSendPatchRequest }
                                />
                            </div>
                        </div>
                    </div>
                    <div className="content__inner">
                        <div className="box">
                            <div className="box__header">
                                <div className="box__title">
                                    Internet Connection Type
                                </div>
                            </div>
                            <div className="box__content box__content--padded">
                                <InternetConnectionForm
                                    data={ this.state.data }
                                    errors={ this.props.personal.errors }
                                    updateValue={ this.updateValue }
                                    updateValueAndSendPatchRequest={ this.updateValueAndSendPatchRequest }
                                />
                            </div>
                        </div>
                    </div>
                    <div className="content__inner">
                        <div className="box">
                            <div className="box__header">
                                <div className="box__title">
                                    Insurance Policies
                                </div>
                            </div>
                            <div className="box__content box__content--padded">
                                <InsuranceForm
                                    data={ this.state.data }
                                    errors={ this.props.personal.errors }
                                    options={ options }
                                    updateValue={ this.updateValue }
                                    updateValueAndSendPatchRequest={ this.updateValueAndSendPatchRequest }
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="submit-row">
                    <Button
                        buttonOnly
                        loading={ this.props.appState.loading || ! this.props.personal }
                        onClick={ this.submitPersonal }
                        status="primary"
                    >
                        Save
                    </Button>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./app/components/personal.js